import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import charlieLancaster from '../public/charlie-lancaster.jpg';
import johnNewland from '../public/john-newland.jpg';
import obs from '../public/obs.jpg';
import russellPollock from '../public/russell-pollock.jpg';
import defaultProfileImage from '../public/tableProfile.png';
import tomBruce from '../public/tom-bruce.jpg';

const TableMembers = [
  { name: 'Russell Pollock', image: russellPollock, role: 'Chairman' },
  { name: 'James Hunt', image: defaultProfileImage, role: 'Immediate Past Chairman' },
  { name: 'John Newland', image: johnNewland, role: 'Vice-Chairman' },
  { name: 'Robin Angland', image: defaultProfileImage, role: 'Vice-Chairman' },
  { name: 'James Walker', image: defaultProfileImage, role: 'Honorary Secretary' },
  { name: 'Andy Fairgrieve', image: defaultProfileImage, role: 'Honorary Treasurer' },
  { name: 'Stuart Allan', image: defaultProfileImage, role: 'Community Service Liaison Officer' },
  {
    name: 'Oliver Harvey-Jones',
    image: defaultProfileImage,
    role: 'Membership & Development Officer'
  },
  { name: 'Josh Smith', image: defaultProfileImage, role: 'Programme' },
  { name: 'Aled Thomas', image: defaultProfileImage, role: 'Member' },
  { name: 'Oliver Bell-Syer', image: obs, role: 'President' },
  { name: 'Thomas Bruce', image: tomBruce, role: 'Member' },
  { name: 'Charlie Lancaster', image: charlieLancaster, role: 'Honorary Member' }
];

export default function Members() {
  return (
    <>
      <Head>
        <title>Members | York Round Table | #DoMore</title>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <div className="mx-auto w-full max-w-screen-xl">
        <article className="mx-auto w-full max-w-screen-lg">
          <h1 className="text-4xl text-rt-orange text-center mb-10">Members</h1>
        </article>
      </div>

      <div className="mx-auto w-full max-w-screen-lg">
        <div className="grid place-items-center grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mb-8 mt-20">
          {TableMembers.map((profile, index) => (
            <div key={index} className="pb-4 bg-rt-profile-text-bg rounded-lg w-full">
              <div className="relative h-80 md:h-50 lg:h-50 overflow-hidden mb-4 rounded-t-lg bg-rt-dark-grey-tint">
                <Image
                  className=""
                  src={profile.image}
                  layout="fill"
                  objectFit="cover"
                  objectPosition="center"
                  placeholder="blur"
                  alt=""
                />
              </div>
              <div>
                <span className="px-4 text-lg text-rt-orange">{profile.name}</span>
                <br />
                <span className="px-4 text-sm text-white">Role: {profile.role}</span>
              </div>
            </div>
          ))}
          <div className="flex justify-center flex-col bg-rt-profile-text-bg text-center rounded-lg h-full w-full p-4">
            <p className="text-rt-orange text-lg py-1">Join us</p>
            <p className="text-white text-sm px-8 py-2">
              Would you like to join us and start to #DoMore
            </p>
            <div className="pt-4">
              <Link href="/get-involved">
                <a className="inline-flex items-center px-6 py-2 border border-rt-orange text-white rounded-full">
                  Get involved
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="ml-2 h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1}
                      d="M17 8l4 4m0 0l-4 4m4-4H3"
                    />
                  </svg>
                </a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
